import { Empty } from "antd";
import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import httpclient from "../../../../service/httpclient";
import "../my_courses/my_courses.scss";
import "./my_live.scss";

function StreamingCourses({ legacy = false, showEmpty = true }) {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [reload, setReload] = useState(0);

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError(false);
    httpclient
      .getStreamingCourses()
      .then((response) => {
        if (!Array.isArray(response)) {
          throw new Error("Invalid streaming courses response");
        }
        if (active) setCourses(response);
      })
      .catch(() => {
        if (active) setError(true);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [reload]);

  return (
    <div className="my-courses-content my-live-list">
      {loading ? (
        <div className="my-live-notice" role="status">
          直播课程加载中...
        </div>
      ) : error ? (
        <div className="my-live-notice" role="alert">
          直播课程加载失败，请稍后重试
          <button className="open-button" onClick={() => setReload(reload + 1)}>
            重新加载
          </button>
        </div>
      ) : courses.length ? (
        <>
          {legacy && <div className="my-courses-subtitle">直播</div>}
          {courses.map((course) => {
            const isSeries = course.itemType === "series";
            // Keep the platform's endpoint: stream IDs are not replay IDs.
            const isReplay = /^\/streaming\/replay\/[1-9]\d*(?:[/?#]|$)/.test(
              course.endpoint || ""
            );
            const action = legacy
              ? "前往"
              : isSeries
              ? "查看课程"
              : isReplay
              ? "观看回放"
              : "查看直播";
            return (
              <div
                className="course streaming-course"
                key={`${course.itemType}-${course.id}`}
              >
                <div className="my-live-course-info">
                  <div className="streaming-course-badge">
                    {isSeries ? "直播课" : "直播场次"}
                  </div>
                  <NavLink to={course.endpoint} className="course-name">
                    {course.name}
                  </NavLink>
                  {!legacy && (
                    <div className="my-live-course-hint">
                      {isReplay ? "回放已上线" : "直播与回放可在课程页面查看"}
                    </div>
                  )}
                </div>
                <NavLink to={course.endpoint} className="open-button">
                  {action}
                </NavLink>
              </div>
            );
          })}
        </>
      ) : showEmpty ? (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={legacy ? "空空如也" : "暂无直播课程"}
        />
      ) : null}
    </div>
  );
}

export default StreamingCourses;
